export function validString(value: any)
{
    return typeof value === 'string' && value.length > 0;
}

export function validInteger(value: any)
{
    return typeof value === 'string' && /^\d+$/.test(value);
}
